import React, { useEffect, useState } from "react";
import { Col, Container, Row, Button, Alert } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Header } from "../../ui/Header";
import { Menu } from "../../ui/Menu";
import { MiniLoader } from "../../ui/MiniLoader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { removeVehicle } from "../../../store/vehicles";
import { ModalConfirmarCreacion } from "./ModalConfirmarCreacion";
import { ModalAddRestrictions } from "./ModalAddRestrictions";
import warning_icon from "../../../assets/images/warning-icon-yellow.svg";
import trash_icon from "../../../assets/images/trash.svg";
import { TablaValidar } from "./TablaValidar";

export const ImportarVehiculosScreen = () => {
  const { nombre, apellido, token } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [isAnyError, setIsAnyError] = useState(
    location.state?.uploadedVehicles ? false : true
  );
  const [showButtons, setShowButtons] = useState(false);
  const [formModified, setFormModified] = useState(false);
  const [modalAdded, setModalAdded] = useState({
    show: false,
    code: "",
    message: "",
  });
  const [isAnyVehicleSelected, setIsAnyVehicleSelected] = useState(false);
  const [nextTapped, setNextTapped] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [validarTapped, setValidarTapped] = useState(false);
  const [deleteTapped, setDeleteTapped] = useState(false);
  const [deleteVehicles, setDeleteVehicles] = useState(1);

  useEffect(() => {
    if (!location.state) {
      navigate("/flotas/importar-vehiculos");
      return;
    }
  }, [location.state]);

  const handleFormModified = (value) => {
    setFormModified(value);
  };

  const changeSelectVehicles = () => {
    setDeleteTapped(true);
    setDeleteVehicles(!deleteVehicles);
    eliminarVehiculos();
    setDeleteTapped(false);
    setIsAnyVehicleSelected(false);
  };

  const eliminarVehiculos = async () => {
    const vehicles = document.querySelectorAll("div.vehiculo");
    vehicles.forEach((vehiculo) => {
      const checkbox = vehiculo.querySelector("input[type=checkbox]");
      if (checkbox.checked) {
        const plate = checkbox.value;
        dispatch(removeVehicle(plate));
      }
    });
  };

  return (
    <>
      <Menu />
      <Container className="content-page">
        <Header name={nombre + " " + apellido} />
        <Container>
          <Row className="page-header pb-4">
            <Col sm={5}>
              <h1>
                <Link
                  to={`/flotas/importar-vehiculos`}
                  className="no-decoration"
                >
                  &lt;
                  {t("flotas.importar-vehiculos.header.h1")}
                </Link>
              </h1>
            </Col>
            <Col sm={7} style={{ textAlign: "right" }}>
              {/* Botón Eliminar */}
              <Button
                variant="outline-primary"
                id="flotas-eliminar"
                onClick={() => {
                  isAnyVehicleSelected && changeSelectVehicles();
                }}
                className={
                  isAnyVehicleSelected
                    ? "flotas-actions-btn-trash me-3 mt-2"
                    : "flotas-actions-btn-trash me-3 mt-2 btn-outline-grey no-pointer"
                }
              >
                <img src={trash_icon} alt="trash" width={17} />
                {t("flotas.table.eliminar")}
              </Button>
              {/* Botón Validar */}
              <Button
                variant="primary"
                className="flotas-btn-add me-3 mt-2"
                disabled={
                  validarTapped || (!isAnyError && !nextTapped && !formModified)
                }
                onClick={() => {
                  setValidarTapped(true);
                  setNextTapped(false);
                }}
              >
                {!validarTapped ? (
                  t("flotas.modal.editar.form.btn-validar")
                ) : (
                  <MiniLoader />
                )}
              </Button>
              {/* Botón Siguiente */}
              <Button
                variant="primary"
                className="flotas-btn-add me-3 mt-2"
                disabled={
                  validarTapped || isAnyError || nextTapped || formModified
                }
                onClick={() => {
                  setNextTapped(true);
                  setShowModal(true);
                }}
              >
                {!nextTapped || !showModal ? (
                  t("flotas.registro-flota.btn-next")
                ) : (
                  <MiniLoader />
                )}
              </Button>
            </Col>
          </Row>
          {isAnyError ? (
            <Row className="px-4" md="auto" style={{ width: "290px" }}>
              <Alert variant="danger-form">
                <img
                  src={warning_icon}
                  className="warning-icon-label filter-primary"
                  alt={t("flotas.fallos.formulario")}
                />
                <b>{t("flotas.fallos.formulario")}</b>
              </Alert>
            </Row>
          ) : (
            <></>
          )}
        </Container>
        {location.state?.uploadedVehicles.length > 0 ? (
          <TablaValidar
            data={location.state?.uploadedVehicles || []}
            token={token}
            setIsAnyError={setIsAnyError}
            isAnyError={isAnyError}
            validarTapped={validarTapped}
            deleteTapped={deleteTapped}
            setValidarTapped={setValidarTapped}
            setDeleteTapped={setDeleteTapped}
            onSelectVehicle={setIsAnyVehicleSelected}
            onFormModified={handleFormModified}
          />
        ) : (
          <Row className="px-4" md="auto">
            <Alert variant="danger-form">
              {t("flotas.importar-vehiculos.alert-empty")}
            </Alert>
          </Row>
        )}
      </Container>
      <ModalConfirmarCreacion
        show={modalAdded.show}
        message={modalAdded.message}
        code={modalAdded.code}
        onHide={() => {
          setModalAdded({
            show: false,
            message: "",
            code: "",
          });
          navigate("/flotas/mis-flotas");
          setValidarTapped(false);
          setNextTapped(false);
          setShowModal(false);
          setDeleteTapped(false);
          setDeleteVehicles(false);
        }}
      />
      <ModalAddRestrictions
        show={showModal}
        onHide={(added = false, code = "", message = "") => {
          if (added) {
            setModalAdded({
              show: true,
              code: code,
              message: message,
            });
            //Cerramos el modal pasados 2 segundos
            setTimeout(() => {
              setModalAdded(false, "");
              navigate("/flotas/mis-flotas");
            }, 2200);
          }
          setShowModal(false);
          setValidarTapped(false);
        }}
      />
    </>
  );
};
